export default class TwoFactorRequiredError extends Error {
  constructor(
    data = {},
    message = 'A verification code is required to finish logging in.',
    code = 428
  ) {
    super(message);
    this.name = this.constructor.name;
    this.data = data;
    this.code = code;

    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(this, this.constructor);
    } else {
      this.stack = new Error(message).stack;
    }
  }

  getChallenge() {
    const {
      challenge,
      channel,
      destination = null,
      expires_at: expiresAt = null,
      can_use_email: canUseEmail = false,
    } = this.data;

    return {
      challenge,
      channel,
      destination,
      expires_at: expiresAt,
      can_use_email: canUseEmail,
    };
  }

  getCode() {
    return this.code;
  }
}
